import axios from 'axios'
import Vue from 'vue'
/**
 * Metodo que busca las categorias de los tickets
 * @param {*} context 
 * @param {*} payload 
 */
export async function fetchEstados(context, payload){
    try{
        let url = "api/getestadosticket"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        
        context.commit('setEstados', response.data)

    }catch(error){
        context.commit('etiquetaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}

/**
 * deprecated 
 * @param {p} context 
 * @param {*} payload 
 */
export async function crearEstadoTicket(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/addestadoticket"//direccion de la api
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=') // siempre agregar el token
        values.append('nombre',payload.nombre)
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        //si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.commit('setIsOk', true);
        //context.dispatch('fetchOrdenes')
    }catch(error){
        context.commit('etiquetaError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function fetchCategorias(context, payload){
    try{
        let url = "api/getticketcategoria"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        
        context.commit('setCategorias', response.data)

    }catch(error){
        context.commit('etiquetaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }

}

export async function buscarEtiquetas(context, payload){
    try{
        let url = "api/getetiquetas"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        values.append('id',payload.id)
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        
        context.commit('setEtiquetas', response.data)

    }catch(error){
        context.commit('etiquetaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function buscarTotalCategorias(context,payload){
    try{
        let url = "api/getticketporcategoria"//direccion de la api
        context.commit('setLoading',true,{root:true})//lanzamiento del loading
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=')
        let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        
        context.commit('setTotalCategorias', response.data)

    }catch(error){
        context.commit('etiquetaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function agregarEtiqueta(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/addetiqueta"//direccion de la api
        let values = new FormData()
        values.append('token','RUMwelVSanJ4OG0xdGI1dVpBVFg=') // siempre agregar el token
        values.append('nombre',payload.nombre)
        values.append('id',payload.id)
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        //si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.commit('setIsOk', true);
        

    }
    catch(error){
        context.commit('etiquetaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}